import { Box, Container, Grid, Pagination, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { apiSearchSchoolsLanding } from '@/modules/schools/services/school.service';
import type {
    SchoolsControllerGetSchoolLandingQueryParams
} from '@/global/api/gen/ts/schoolsDTO/SchoolsControllerGetSchoolLanding';
import { AutoSchoolCard } from './AutoSchoolCard';

interface Props {
    params: Omit<SchoolsControllerGetSchoolLandingQueryParams, 'offset' | 'limit'>;
}

export function AutoSchoolsList({params}: Props) {

    const [currentPage, setCurrentPage] = useState(0);
    const pageSize = 20;

    const {data: schoolsData, isLoading} = apiSearchSchoolsLanding({
        ...params,
        limit: pageSize,
        offset: currentPage * pageSize
    });

    return (
        <>
            <Container maxWidth={'lg'}>
                <Stack spacing={2}>
                    {schoolsData?.items.map((school) => (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                            key={school.id}
                        >
                            <AutoSchoolCard school={school}/>
                        </Grid>
                    ))}
                </Stack>
                {
                    !!schoolsData?.items.length && (
                    <Stack
                        sx={{
                            marginTop: 2,
                            alignItems: 'flex-end'
                        }}
                    >
                        <Pagination
                            page={currentPage + 1}
                            onChange={(_event, page) => setCurrentPage(page - 1)}
                            count={schoolsData ? Math.ceil(schoolsData.total / pageSize) : 1}
                        />
                    </Stack>
                  )}
                <Box>
                    {
                        (isLoading || !schoolsData?.items.length) && (
                            <Box height={'150px'}>
                                {schoolsData?.items.length === 0 && (
                                    <Box sx={{textAlign: 'center', py: 8}}>
                                        <Typography
                                            variant="h6"
                                            sx={{color: '#5a6c7d', mb: 2}}
                                        >
                                            Автошколы не найдены
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            sx={{color: '#7a8a9a'}}
                                        >
                                            Попробуйте изменить параметры поиска или очистить фильтры
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}
                </Box>
            </Container>
        </>
    );
}